export default __webpack_public_path__ + "static/media/profile-1.cc1390f8.jpeg";